
export const LINK_TARGET = {
  SELF: '_self',
  BLANK: '_blank',
  PARENT: 'parent',
  TOP: '_top',
};
